import React, {useEffect} from 'react';

interface ModalProps {
  isOpen: boolean;
  title?: string;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({title, isOpen, onClose, children}) => {
  useEffect(() => {
    if (isOpen) {
      document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
    } else {
      document
        .getElementsByTagName('body')[0]
        .classList.remove('overflow-hidden');
    }
  }, [isOpen]);
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-14 bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl mx-4 flex flex-col max-h-[90vh]">
        <div className="h-auto p-6  border-b border-slate-200 flex justify-between items-start gap-2 w-full">
          <div className="flex flex-col justify-start items-start gap-1">
            {title && (
              <div className="text-lg font-semibold tracking-normal text-slate-600">
                {title}
              </div>
            )}
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none "
            aria-label="Cerrar">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="flex-1 px-3 pb-6 pt-3 overflow-y-auto">
          <div className="h-full flex flex-col overflow-y-auto overflow-hidden">
            <div className="h-full px-4">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
